'use strict';

// If a permission is added here add it also in the baseRole
module.exports = {
  ADMIN_GLOBAL: 'ADMIN_GLOBAL',
  ADMIN_CLIENT: 'ADMIN_CLIENT',

  ADMIN_ACTIVITIES: 'ADMIN_ACTIVITIES',
  ADMIN_ACTIVITIES_CREATE: 'ADMIN_ACTIVITIES_CREATE',
  ADMIN_ACTIVITIES_READ: 'ADMIN_ACTIVITIES_READ',
  ADMIN_ACTIVITIES_UPDATE: 'ADMIN_ACTIVITIES_UPDATE',
  ADMIN_ACTIVITIES_DELETE: 'ADMIN_ACTIVITIES_DELETE',

  ADMIN_SEGMENTS: 'ADMIN_SEGMENTS',
  ADMIN_SEGMENTS_CREATE: 'ADMIN_SEGMENTS_CREATE',
  ADMIN_SEGMENTS_READ: 'ADMIN_SEGMENTS_READ',
  ADMIN_SEGMENTS_UPDATE: 'ADMIN_SEGMENTS_UPDATE',
  ADMIN_SEGMENTS_DELETE: 'ADMIN_SEGMENTS_DELETE',

  ADMIN_USER_CLIENTS: 'ADMIN_USER_CLIENTS',
  ADMIN_USER_CLIENTS_CREATE: 'ADMIN_USER_CLIENTS_CREATE',
  ADMIN_USER_CLIENTS_READ: 'ADMIN_USER_CLIENTS_READ',
  ADMIN_USER_CLIENTS_UPDATE: 'ADMIN_USER_CLIENTS_UPDATE',
  ADMIN_USER_CLIENTS_DELETE: 'ADMIN_USER_CLIENTS_DELETE',

  ADMIN_USER_GROUPS: 'ADMIN_USER_GROUPS',
  ADMIN_USER_GROUPS_CREATE: 'ADMIN_USER_GROUPS_CREATE',
  ADMIN_USER_GROUPS_READ: 'ADMIN_USER_GROUPS_READ',
  ADMIN_USER_GROUPS_UPDATE: 'ADMIN_USER_GROUPS_UPDATE',
  ADMIN_USER_GROUPS_DELETE: 'ADMIN_USER_GROUPS_DELETE',

  ADMIN_GROUPS: 'ADMIN_GROUPS',
  ADMIN_GROUPS_CREATE: 'ADMIN_GROUPS_CREATE',
  ADMIN_GROUPS_READ: 'ADMIN_GROUPS_READ',
  ADMIN_GROUPS_UPDATE: 'ADMIN_GROUPS_UPDATE',
  ADMIN_GROUPS_DELETE: 'ADMIN_GROUPS_DELETE',

  ADMIN_COLLECTIONS: 'ADMIN_COLLECTIONS',
  ADMIN_COLLECTIONS_CREATE: 'ADMIN_COLLECTIONS_CREATE',
  ADMIN_COLLECTIONS_READ: 'ADMIN_COLLECTIONS_READ',
  ADMIN_COLLECTIONS_UPDATE: 'ADMIN_COLLECTIONS_UPDATE',
  ADMIN_COLLECTIONS_DELETE: 'ADMIN_COLLECTIONS_DELETE',

  ADMIN_ARTICLES: 'ADMIN_ARTICLES',
  ADMIN_ARTICLES_CREATE: 'ADMIN_ARTICLES_CREATE',
  ADMIN_ARTICLES_READ: 'ADMIN_ARTICLES_READ',
  ADMIN_ARTICLES_UPDATE: 'ADMIN_ARTICLES_UPDATE',
  ADMIN_ARTICLES_DELETE: 'ADMIN_ARTICLES_DELETE',

  ADMIN_REWARDS: 'ADMIN_REWARDS',
  ADMIN_REWARDS_CREATE: 'ADMIN_REWARDS_CREATE',
  ADMIN_REWARDS_READ: 'ADMIN_REWARDS_READ',
  ADMIN_REWARDS_UPDATE: 'ADMIN_REWARDS_UPDATE',
  ADMIN_REWARDS_DELETE: 'ADMIN_REWARDS_DELETE',

  ADMIN_CHALLENGES: 'ADMIN_CHALLENGES',
  ADMIN_CHALLENGES_CREATE: 'ADMIN_CHALLENGES_CREATE',
  ADMIN_CHALLENGES_READ: 'ADMIN_CHALLENGES_READ',
  ADMIN_CHALLENGES_UPDATE: 'ADMIN_CHALLENGES_UPDATE',
  ADMIN_CHALLENGES_DELETE: 'ADMIN_CHALLENGES_DELETE',

  ADMIN_PROGRAMS: 'ADMIN_PROGRAMS',
  ADMIN_PROGRAMS_CREATE: 'ADMIN_PROGRAMS_CREATE',
  ADMIN_PROGRAMS_READ: 'ADMIN_PROGRAMS_READ',
  ADMIN_PROGRAMS_UPDATE: 'ADMIN_PROGRAMS_UPDATE',
  ADMIN_PROGRAMS_DELETE: 'ADMIN_PROGRAMS_DELETE',

  ADMIN_FEATURE_CONFIGS: 'ADMIN_FEATURE_CONFIGS',
  ADMIN_FEATURE_CONFIGS_CREATE: 'ADMIN_FEATURE_CONFIGS_CREATE',
  ADMIN_FEATURE_CONFIGS_READ: 'ADMIN_FEATURE_CONFIGS_READ',
  ADMIN_FEATURE_CONFIGS_UPDATE: 'ADMIN_FEATURE_CONFIGS_UPDATE',
  ADMIN_FEATURE_CONFIGS_DELETE: 'ADMIN_FEATURE_CONFIGS_DELETE',
  ADMIN_FEATURE_CONFIGS_PARTIAL_UPDATE: 'ADMIN_FEATURE_CONFIGS_PARTIAL_UPDATE',

  ADMIN_USER_PROGRAMS_READ: 'ADMIN_USER_PROGRAMS_READ',

  ADMIN_USERS: 'ADMIN_USERS',

  ADMIN_EXPORTS: 'ADMIN_EXPORTS',

  ADMIN_PAYMENTS: 'ADMIN_PAYMENTS',

  ADMIN_IMAGES_UPLOAD: 'ADMIN_IMAGES_UPLOAD',

  ADMIN_FEED_MODERATION: 'ADMIN_FEED_MODERATION',

  ADMIN_TRANSLATOR: 'ADMIN_TRANSLATOR',
};
